import { render, staticRenderFns } from "./CreditNotes.vue?vue&type=template&id=7edfd9c4&scoped=true"
import script from "./CreditNotes.vue?vue&type=script&lang=js"
export * from "./CreditNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edfd9c4",
  null
  
)

export default component.exports